var _path, _circle, _circle2, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.0532 17.8043C29.058 19.6414 28.6288 21.4536 27.8005 23.0933C25.7976 27.1009 21.7027 29.6333 17.2225 29.635C15.3855 29.6398 13.5733 29.2106 11.9335 28.3824L4 31.0269L6.6445 23.0933C5.81626 21.4536 5.38705 19.6414 5.39184 17.8043C5.39358 13.3241 7.92594 9.22925 11.9335 7.22633C13.5733 6.39809 15.3855 5.96888 17.2225 5.97367H17.9184C23.9254 6.30507 28.7218 11.1015 29.0532 17.1084V17.8043Z",
    stroke: "#9A9BA5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.5264,
    cy: 17.5,
    r: 1.5,
    fill: "#9A9BA5"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5264,
    cy: 17.5,
    r: 1.5,
    fill: "#9A9BA5"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.5264,
    cy: 17.5,
    r: 1.5,
    fill: "#9A9BA5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.7cbaa33474a989e4a703e5c2c1d5ae16.svg";
export { ForwardRef as ReactComponent };